import { Injectable } from "@angular/core";
import { ISearchResult } from "@ramudden/models/search";
import { IMeasuringPointSummary, MeasuringPointSearchParameters } from "@ramudden/models/web";
import { firstValueFrom } from "rxjs";
import { WebApiService } from "./web-api";

@Injectable({
    providedIn: "root",
})
export class MeasuringPointWebApi extends WebApiService<IMeasuringPointSummary> {
    override getRoute(): string {
        return "MeasuringPoints";
    }

    // Typed implementation of the base method that can be awaited
    async search(parameters: MeasuringPointSearchParameters): Promise<ISearchResult<IMeasuringPointSummary>> {
        const url = this.getUrl();
        const params = parameters.getHttpParams();
        const obs = this.http.get<ISearchResult<IMeasuringPointSummary>>(url, { params: params });
        const result = await firstValueFrom(obs);
        return result;
    }
}
